module.exports = __webpack_public_path__ + "img/button_gold.ca04ad26.png";